import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { Invitation } from '../types/invitation';

async function acceptInvitation(id: string): Promise<{ invitation: Invitation }> {
    const { data } = await api.post(`/profile/invitations/${id}`);
    return data;
}

export function useAcceptInvitation(refresh = true): UseMutationResult<{ invitation: Invitation }, AxiosError, string, unknown> {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(acceptInvitation, {
        onSuccess: async () => {
            if (refresh) {
                await getAccessTokenSilently({ cacheMode: 'off' });
            }
        },
    });
}
